import React from 'react'
import { Button, Image, Modal } from 'semantic-ui-react'
import styled from 'styled-components'

const StyledButton = styled(Button)`
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    margin-top: 10px !important;
    width: 100%;
  }
`

export const CertificateButton = ({ certificate, fluid }) => (
  <Modal
    trigger={
      <StyledButton fluid={fluid ? true : null} color="teal">
        Certificate
      </StyledButton>
    }
  >
    <Modal.Header>Certificate</Modal.Header>
    <Modal.Content>
      <Modal.Description>
        <Image wrapped fluid src={certificate} />
        <div style={{ textAlign: 'center' }}>
          <a href={certificate} download>
            <Button color="teal" className="mt10">
              Download
            </Button>
          </a>
        </div>
      </Modal.Description>
    </Modal.Content>
  </Modal>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/organisms/CertificateButton/index.js